import React from "react";
import "../styles/PatientCard.css";
import PatientIDVerificationDisplay from "./PatientIDVerificationDisplay";

interface Patient {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  region: string;
  city: string;
  dob: string;
  phone: string;
  idFront?: string; // S3 key for front ID image
  selfie?: string; // S3 key for selfie image
  idBack?: string;
}

const PatientCard: React.FC<{ patient: Patient }> = ({ patient }) => {
  // Build verification data using the patient profile's image keys.
  const verificationData = {
    verified: !!(patient.idFront && patient.selfie),
    idImageUrl: patient.idFront, // S3 key for the front ID image
    selfieImageUrl: patient.selfie, // S3 key for the selfie
    // similarity can be omitted if not stored
  };

  return (
    <div className="patient-card">
      <div className="patient-info-section">
        <h2>
          {patient.firstName} {patient.lastName}
        </h2>
        <p>
          <strong>Email:</strong> {patient.email}
        </p>
        <p>
          <strong>State:</strong> {patient.region}
        </p>
        <p>
          <strong>City:</strong> {patient.city}
        </p>
        <p>
          <strong>Date of Birth:</strong>{" "}
          {new Date(patient.dob).toLocaleDateString()}
        </p>
        <p>
          <strong>Phone:</strong> {patient.phone}
        </p>
      </div>

      <PatientIDVerificationDisplay verification={verificationData} />
    </div>
  );
};

export default PatientCard;
